var $ = require("jquery");
require('imports-loader?jQuery=jquery!ajaxchimp');

if (require("cookies-utils").read('localecookie') == "fr-ca") {
    $.ajaxChimp.translations = {
        'fr': {
            'submit': 'Enregistrement en cours...',
            0: 'Nous vous avons envoyé un e-mail de confirmation',
            1: 'S\'il vous plaît entrer une valeur',
            2: 'Une adresse e-mail doit contenir un seul @',
            3: 'La partie domaine de l\'adresse e-mail n\'est pas valide (la partie après le @:)',
            4: 'La partie nom d\'utilisateur de l\'adresse email n\'est pas valide (la partie avant le signe @:)',
            5: 'Cette adresse e-mail semble fausse ou non valide. S\'il vous plaît entrer une adresse email valide'
        }
    }
}


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/mailchimp-ajax/index.js
 ** module id = 71
 ** module chunks = 0 1
 **/